import moment from "moment-timezone";

import flag_en from "../assets/img/flags/flag_en.png";
import flag_nl from "../assets/img/flags/flag_nl.png";
import { localeMap } from "../config/locales.js";

const CHARS =
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
/**
 * Maps a locale string ('en' or 'nl') to a date-fns locale object.
 * Defaults to enUS if the provided locale is not found.
 *
 * @param {string} localeString - The locale string (like 'nl').
 * @returns {Object} The corresponding date-fns locale object.
 */
export const getDateLocale = (localeString) => localeMap[localeString] || enUS;

export const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w-]+/g, "") // Remove all non-word chars
    .replace(/--+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text

export const validateEmailAddress = (emailAddress) =>
  !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    emailAddress,
  );

export const uuid = (len, radix = CHARS.length) => {
  const result = [];
  if (len) {
    // Generate a compact form
    for (let i = 0; i < len; i++) {
      result[i] = CHARS[Math.floor(Math.random() * radix)];
    }
  } else {
    // Generate an RFC4122, version 4 UUID
    // Positions 8, 13, 18, and 23 are hyphens
    result[8] = result[13] = result[18] = result[23] = "-";
    // The 14th character is '4'
    result[14] = "4";

    for (let i = 0; i < 36; i++) {
      if (!result[i]) {
        const r = Math.floor(Math.random() * 16);
        // For position 19, set high bits of clock sequence per RFC4122
        result[i] = CHARS[i === 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return result.join("");
};

export const localeFlags = {
  en: flag_en,
  nl: flag_nl,
};

export const formatLocalDate = (date) =>
  moment(date).tz("Europe/Amsterdam").format("DD-MM-YYYY HH:mm");
